<template>
  <div>
    <Slide>
      <router-link to="/home/items" class="text-secondary">
        Items
      </router-link>
      <router-link to="/home/images" class="text-secondary">
        Images
      </router-link>
      <router-link to="/home/live" class="text-secondary">
        Live
      </router-link>
      <router-link to="/logout" class="text-secondary">
        Logout
      </router-link>
    </Slide>
    <router-view></router-view>
  </div>
</template>

<script>
import { Slide } from "vue-burger-menu";

export default {
  name: "Home",
  components: {
    Slide
  }
};
</script>
